<template>
  <v-app>
    <v-main>
      <div class="content-wrapper">
        <!-- Content Header -->
        <div class="content-header">
          <div
            class="d-flex align-items-center"
            style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
          >
            <div class="row">
              <div class="col-12 d-flex flex-column align-items-baseline">
                <h1 class="m-0 text-dark">Clients Management</h1>
                <ol class="breadcrumb float-sm-left">
                  <router-link
                    tag="li"
                    class="breadcrumb-item"
                    :to="{ name: 'Home' }"
                    >Home</router-link
                  >
                  <router-link
                    tag="li"
                    class="breadcrumb-item"
                    :to="{ name: 'Dashboard' }"
                    >Dashboard</router-link
                  >
                  <li class="breadcrumb-item active">Clients Management</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Main Content -->
        <div class="row p-3">
          <!-- <div class="w-100">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="mb-3"
              style="width: 50%"
            ></v-text-field>
          </div> -->
          <div class="col-12">
            <v-data-table
              :headers="headers"
              :items="clients"
              :search="search"
              :loading="!clients.length || false"
              :expanded.sync="expanded"
              single-expand
              show-expand
              item-key="client_uid"
              loading-text="Loading ..."
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat class="p-0">
                  <v-toolbar-title>Clients</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="width-fit-content ml-4"
                    style="height: 34px !important"
                    @click="shwClientCreation = true"
                    color="primary"
                    elevation="2"
                    x-small
                    >Create Client</v-btn
                  >
                </v-toolbar>
              </template>
              <template v-slot:[`item.synced_clusters`]="{ item }">
                <td class="pt-5 text-center border-right">
                  <v-select
                    v-model="item.cluster_id"
                    :value="item.cluster ? item.cluster.id : ''"
                    :items="clusters"
                    item-text="cluster_name"
                    item-value="id"
                    label="Select the cluster"
                    dense
                    clearable
                    :loading="!clusters.length || false"
                    :menu-props="{
                      closeOnClick: false,
                      closeOnContentClick: false,
                    }"
                  >
                    <template #append-item>
                      <div class="d-flex justify-center pt-3">
                        <v-btn
                          color="primary"
                          elevation="2"
                          plain
                          x-small
                          style="height: 27px !important"
                          @click="
                            questionType = 'sync';
                            updateClientObj(item);
                          "
                          >Sync</v-btn
                        >
                      </div>
                    </template>
                  </v-select>
                </td>
              </template>
              <template v-slot:[`item.image_storage`]="{ item }">
                <td class="border-right">
                  <v-text-field
                    v-model="item.images_storage_public_folder"
                    :height="70"
                    @blur="
                      targetedObj = item;
                      targetType = 'image_storage_path';
                      updateImageStorage();
                    "
                    label="Image storage path"
                  ></v-text-field>
                </td>
              </template>
              <template v-slot:[`item.edit_image_storage_config`]="{ item }">
                <v-btn
                  class="width-fit-content"
                  elevation="2"
                  x-small
                  dense
                  style="height: 34px !important"
                  @click="
                    targetedObj = item.cluster;
                    targetType = 'image_storage_config';
                    shwEditImageConfig = true;
                  "
                >
                  Edit Image Storage Config
                </v-btn>
              </template>
              <template v-slot:[`item.create_user`]="{ item }">
                <v-btn
                  class="width-fit-content"
                  color="primary"
                  elevation="2"
                  x-small
                  dense
                  style="height: 34px !important"
                  @click="
                    shwUserCreation = true;
                    user.client_uid = item.client_uid;
                  "
                >
                  Create a user
                </v-btn>
              </template>
              <template v-slot:[`item.is_active`]="{ item }">
                <td>
                  <v-switch
                    v-model="item.is_active"
                    label="Switch Client Activeness"
                    :loading="processLoading"
                    @change="
                      questionType = 'activeness';
                      item.is_active = item.is_active ? 1 : 0;
                      updateClientObj(item);
                    "
                  ></v-switch>
                </td>
              </template>
              <template v-slot:expanded-item="{ item }">
                <td class="pt-2 px-0 border-right text-center">
                  <h6 class="border-bottom pt-2 pb-3">User Id</h6>
                  <p
                    v-for="(user, i) in item.users"
                    :key="i"
                    class="mt-6 mb-0"
                    :class="{
                      'height-21': !user.id,
                      'height-34': user.id,
                    }"
                  >
                    {{ user.id }}
                  </p>
                </td>
                <td colspan="1" class="pt-2 px-0 border-right text-center">
                  <h6 class="border-bottom pt-2 pb-3">User Name</h6>
                  <p
                    v-for="(user, i) in item.users"
                    :key="i"
                    class="mb-0 mt-6"
                    :class="{
                      'height-21': !user.name,
                      'height-34': user.name,
                    }"
                  >
                    {{ user.name }}
                  </p>
                </td>
                <td colspan="3" class="pt-2 px-0 border-right text-center">
                  <h6 class="border-bottom pt-2 pb-3">Email</h6>
                  <p
                    v-for="(user, i) in item.users"
                    :key="i"
                    class="mt-6 mb-0"
                    :class="{
                      'height-21': !user.email,
                      'height-34': user.email,
                    }"
                  >
                    {{ user.email }}
                  </p>
                </td>
                <td
                  style="width: 280px; border: none"
                  class="pt-6 border-right text-center px-0 d-flex flex-column align-items-center"
                >
                  <h6 class="w-100 border-bottom pb-2">Roles To Sync</h6>
                  <v-select
                    v-for="(user, i) in item.users"
                    :key="i"
                    v-model="user.roles"
                    :items="getRoles"
                    item-text="name"
                    item-value="id"
                    dense
                    height="34px"
                    full-width
                    class="m-0"
                    :loading="!getRoles.length || false"
                  >
                    <template #label>
                      {{
                        user.roles.length ? user.roles[0].name : "Select a Role"
                      }}
                    </template>
                    <template #append-item>
                      <div class="d-flex justify-center pt-3">
                        <v-btn
                          color="primary"
                          elevation="2"
                          plain
                          x-small
                          style="height: 27px !important"
                          @click="
                            questionType = 'sync';
                            updateUserObj(user);
                          "
                          >Sync</v-btn
                        >
                      </div>
                    </template>
                  </v-select>
                </td>
                <td class="pt-5 px-0 border-left text-center">
                  <h6 class="w-100 border-bottom pb-2">Permissions To Sync</h6>
                  <v-select
                    v-for="(user, i) in item.users"
                    :key="i"
                    v-model="user.permissions"
                    :items="permissions"
                    item-text="name"
                    item-value="id"
                    dense
                    height="34px"
                    multiple
                    full-width
                    clearable
                    class="m-0"
                    :loading="!permissions.length || false"
                  >
                    <template #append-item>
                      <div class="d-flex justify-center pt-3">
                        <v-btn
                          color="primary"
                          elevation="2"
                          plain
                          x-small
                          style="height: 27px !important"
                          @click="
                            questionType = 'sync';
                            updateUserPermissions(user);
                          "
                          >Sync</v-btn
                        >
                      </div>
                    </template>
                  </v-select>
                </td>
                <td class="pt-2 px-2 border-left text-center">
                  <v-switch
                    v-for="(user, i) in item.users"
                    :key="i"
                    class="height-34 mb-0"
                    :class="[i === 0 ? 'mt-12' : 'mt-6']"
                    v-model="user.is_active"
                    @change="
                      questionConfirmBtnText = 'Change';
                      questionType = 'activeness';
                      targetedObj = user;
                      targetType = 'user update';
                      shwQuestion = true;
                    "
                  ></v-switch>
                </td>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>

      <!-- Dialog window to create a user -->
      <v-dialog
        v-model="shwUserCreation"
        v-if="shwUserCreation"
        persistent
        width="350px"
      >
        <v-card style="margin: 0 !important">
          <v-card-title class="justify-content-center">
            <span class="text-h5">Create new user</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center" dense>
                <!-- Name -->
                <v-col cols="12">
                  <v-text-field
                    label="Name*"
                    v-model="user.name"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <!-- Email -->
                <v-col cols="12">
                  <v-text-field
                    label="Email*"
                    v-model="user.email"
                    type="email"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <!-- Password -->
                <v-col cols="12">
                  <v-text-field
                    label="Password*"
                    :append-icon="shwPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="shwPassword ? 'text' : 'password'"
                    @click:append="shwPassword = !shwPassword"
                    v-model="user.password"
                    :rules="[rules.required, rules.password_length]"
                    :loading="processLoading"
                    counter
                    required
                  ></v-text-field>
                </v-col>
                <!-- Password Confirmation -->
                <v-col cols="12">
                  <v-text-field
                    label="Confirm Password*"
                    :append-icon="
                      shwConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    :type="shwConfirmPassword ? 'text' : 'password'"
                    @click:append="shwConfirmPassword = !shwConfirmPassword"
                    v-model="user.password_confirmation"
                    :rules="[rules.required, rules.password_confirmation]"
                    :loading="processLoading"
                    counter
                    required
                  ></v-text-field>
                </v-col>
                <!-- Roles -->
                <v-col cols="12">
                  <v-select
                    label="Role*"
                    v-model="user.role_name"
                    :items="getRoles"
                    item-text="name"
                    item-value="name"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                    class="w-100"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <!-- Actions -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-2"
              text
              :disabled="processLoading"
              @click="shwUserCreation = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-2"
              text
              :loading="processLoading"
              @click="createUser()"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog window to edit image storage config -->
      <v-dialog
        v-model="shwEditImageConfig"
        v-if="shwEditImageConfig"
        persistent
        width="350px"
      >
        <v-card style="margin: 0 !important">
          <v-card-title class="justify-content-between">
            <span class="text-h5">Image Storage Config</span>
            <i
              class="bi-clipboard cursor-pointer"
              @click="copyToClipboard('Image storage config')"
            ></i>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center" dense>
                <!-- Username & Password Cols -->
                <v-col cols="12">
                  <v-text-field
                    label="Username*"
                    v-model="targetedObj.images_storage.IMAGES_STORAGE_USERNAME"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Password*"
                    v-model="targetedObj.images_storage.IMAGES_STORAGE_PASSWORD"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    :append-icon="shwPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="shwPassword ? 'text' : 'password'"
                    @click:append="shwPassword = !shwPassword"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Divider -->
                <div class="px-0">
                  <v-divider light></v-divider>
                </div>

                <!-- Public Domain & Public Doc Root & Public Root Cols -->
                <v-col cols="12">
                  <v-text-field
                    label="Public Domain*"
                    v-model="
                      targetedObj.images_storage.IMAGES_STORAGE_PUBLIC_DOMAIN
                    "
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Public Doc Root*"
                    v-model="targetedObj.images_storage.IMAGES_STORAGE_DOC_ROOT"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Public Root*"
                    v-model="
                      targetedObj.images_storage.IMAGES_STORAGE_PUBLIC_ROOT
                    "
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Divider -->
                <div class="px-0">
                  <v-divider light></v-divider>
                </div>

                <!-- Host & Driver Cols -->
                <v-col cols="9">
                  <v-text-field
                    label="Host*"
                    v-model="targetedObj.images_storage.IMAGES_STORAGE_HOST"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Driver*"
                    v-model="targetedObj.images_storage.IMAGES_STORAGE_DRIVER"
                    :rules="[rules.required]"
                    :loading="processLoading"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-2"
              text
              :disabled="processLoading"
              @click="shwEditImageConfig = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-2"
              text
              :loading="processLoading"
              @click="
                targetType = 'image_storage_config';
                updateImageStorage();
              "
            >
              Edit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <!-- Question Pop Up -->
        <Question
          v-if="shwQuestion"
          @didClose="shwQuestion = false"
          @confirmed="confirm"
          @notConfirmed="shwQuestion = false"
          title="Are you sure?"
          :text="questionText"
          :confirmButtonText="questionConfirmBtnText"
          :cancelButtonText="questionDismissBtnText"
          confirmButtonClasses="btn btn-success"
          cancelButtonClasses="btn btn-danger"
          successIcon="success"
          errorIcon="error"
        />
      </transition>

      <!-- Success Snackbar -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <SuccessSnackbar
          v-if="success"
          :message="successText"
          @update-success="handleUpdateToSuccessSnackbar"
        />
      </transition>

      <!-- Failure Snackbar -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <FailureSnackbar
          v-if="failure"
          :message="failureText"
          @update-failure="handleUpdateToFailureSnackbar"
        />
      </transition>

      <!-- Warning Pop Up -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <Warnings
          v-if="warning"
          @didClose="warning = false"
          :warningText="warningText"
        />
      </transition>

      <!-- Error Pop Up -->
      <Error
        v-if="rolesError || clusterError || clientError"
        :error="clientError || clusterError || rolesError"
      />

      <!-- Spinner -->
      <Spinner
        v-if="loading"
        class="loading-spinner--center position-fixed"
        style="z-index: 99999"
      />
    </v-main>
    <pre style="display: none">
      textaaaa
    </pre>
    <!-- Dialog window to create a client -->
    <v-dialog
      v-model="shwClientCreation"
      v-if="shwClientCreation"
      persistent
      width="350px"
      @click:outside="closeCreateClientDialog()"
    >
      <v-card style="margin: 0 !important">
        <v-card-title class="justify-content-center">
          <span class="text-h5">Create new client</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" dense>
              <v-col cols="6">
                <v-text-field
                  label="Name*"
                  v-model="clientForm.name"
                  :rules="[rules.required]"
                  :loading="processLoading"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Email*"
                  v-model="clientForm.email"
                  :rules="[rules.required, rules.email]"
                  :loading="processLoading"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Password*"
                  v-model="clientForm.password"
                  :rules="[rules.required, rules.password_length]"
                  :loading="processLoading"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Confirmation Password*"
                  v-model="clientForm.password_confirmation"
                  :rules="[rules.required, rules.password_confirmation_client]"
                  :loading="processLoading"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- Actions -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-2"
            text
            :disabled="processLoading"
            @click="closeCreateClientDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-2"
            text
            :loading="processLoading"
            @click="createAClient()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import DialogWindow from "../popUps/DialogWindow.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Question from "../popUps/Question.vue";
import Warnings from "../popUps/Warnings.vue";
import Error from "../popUps/Error.vue";
import Spinner from "../popUps/Spinner.vue";
import common from "../../mixins/common";
import User from "../../apis/User";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "Clients",
  components: {
    DialogWindow,
    SuccessSnackbar,
    FailureSnackbar,
    Warnings,
    Question,
    Spinner,
    Error,
  },
  mixins: [common],
  data() {
    return {
      textToCopy: "test111",
      questionType: "",
      questionText: "",
      questionConfirmBtnText: "",
      questionDismissBtnText: "Cancel",

      expanded: [],
      selectedClusters: [],
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        password_length: (value) =>
          value.length >= 8 || "The password must be at least 8 characters.",
        password_confirmation: (value) =>
          value === this.user.password ||
          "The password confirmation does not match.",
        password_confirmation_client: (value) =>
          value === this.clientForm.password ||
          "The password confirmation does not match.",
      },

      clientForm: {
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
      },

      //target: "",
      targetedObj: {},

      success: false,
      successText: "",
      failure: false,
      failureText: "",
      warning: false,
      warningText: "",

      shwUserCreation: false,
      shwEditImageConfig: false,
      shwQuestion: false,
      shwPassword: false,
      shwConfirmPassword: false,
      shwClientCreation: false,

      id: null,

      headers: [
        {
          text: "Client Id",
          value: "client_uid",
          align: "start",
          sortable: false,
          divider: true,
          class: "table-header--color border-left",
          cellClass: "border-left",
        },
        {
          text: "Client Name",
          value: "name",
          align: "start",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Synced Clusters",
          value: "synced_clusters",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Image Storage",
          value: "image_storage",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Create User",
          value: "create_user",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Edit Config",
          value: "edit_image_storage_config",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Activeness",
          value: "is_active",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
      ],

      loading: false,
      processLoading: false,

      search: "",

      user: {
        name: "",
        password: "",
        password_confirmation: "",
        email: "",
        client_uid: "",
        role_name: "",
      },
    };
  },
  mounted() {
    this.getAllRoles();
    this.getAllPermissions();
    this.getAllClients();
    this.getAllClusters();
  },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions.permissions,
      clusters: (state) => state.clusters.clusters,
      clients: (state) => state.clients.clients,
      clientError: (state) => state.clients.clientError,
      clusterError: (state) => state.clusters.clusterError,
      rolesError: (state) => state.roles.roleError,
    }),
    ...mapGetters(["getClients", "getRoles"]),
  },
  methods: {
    ...mapActions([
      "getAllClients",
      "getAllRoles",
      "getAllPermissions",
      "getAllClusters",
      "updateUser",
      "updateClient",
      "updateCluster",
      "registerUser",
      "addUserToClient",
    ]),

    createAClient() {
      if (
        !this.clientForm.name ||
        !this.clientForm.email ||
        !this.clientForm.password ||
        !this.clientForm.password_confirmation
      ) {
        this.failureText = "Fill the required fields!";
        this.failure = true;

        return false;
      }

      if (this.clientForm.password !== this.clientForm.password_confirmation) {
        this.failureText = "The password confirmation does not match!";
        this.failure = true;

        return false;
      }

      this.processLoading = true;

      User.registerClient(this.clientForm)
        .then(() => {
          this.successText = "Client has been successfully created!";
          this.success = true;

          this.getAllClients();

          this.closeCreateClientDialog();
        })
        .catch((error) => {
          console.error(error);

          this.failureText = "Fail to create the client!";
          this.failure = true;
        })
        .finally(() => {
          setTimeout(() => {
            this.processLoading = false;
          });
        });
    },
    closeCreateClientDialog() {
      this.shwClientCreation = false;

      this.clientForm = {
        name: "",
        password: "",
        password_confirmation: "",
        email: "",
      };
    },
    runLoading() {
      this.processLoading = true;
      document.body.style.cursor = "wait";

      setTimeout(() => {
        this.processLoading = false;
        document.body.style.cursor = "default";
      }, 1000);
    },
    copyToClipboard(type) {
      this.writeTextToClipboard(this.targetedObj).then(() => {
        this.successText = `${type} has been copied to clipboard successfully!`;
        this.success = true;
      });
    },
    confirm() {
      if (this.targetType === "cluster") {
        this.handleUpdateRequestToClientObj();
      } else if (this.targetType === "user update") {
        this.handleUpdateRequestToUser();
      } else if (this.targetType === "role") {
        this.targetedObj = new Object({
          id: this.targetedObj.id,
          roles: this.targetedObj.roles,
        });

        this.handleUpdateRequestToUserObj();
      } else if (this.targetType === "permissions") {
        this.targetedObj = new Object({
          id: this.targetedObj.id,
          permissions: this.targetedObj.permissions,
        });

        this.handleUpdateRequestToUserPermissions();
      } else if (this.targetType === "image_storage_config") {
        this.handleUpdateRequestToImageStorageConfig();
      } else if (this.targetType === "image_storage_path") {
        this.handleUpdateRequestToImageStoragePath();
      }
    },
    handleUpdateRequestToUser() {
      this.runLoading();

      delete this.targetedObj.cluster;
      delete this.targetedObj.users;

      this.updateUser({
        id: this.targetedObj.id,
        obj: { id: this.targetedObj.id, is_active: this.targetedObj.is_active },
      })
        .then(() => {
          this.success = true;
          this.successText = "User has been updated successfully!";
        })
        .catch(() => {
          this.failure = true;
          this.failureText = "Fail to update the user!";
        });
    },
    createUser() {
      this.runLoading();

      this.registerUser(this.user)
        .then((response) => {
          return response.data.data;
        })
        .then((response) => {
          this.name = "";
          this.password = "";
          this.password_confirmation = "";
          this.email = "";
          this.client_uid = "";
          this.role_name = "";

          this.shwPassword = false;
          this.shwConfirmPassword = false;

          this.successText = "User has been created successfully!";
          this.success = true;

          this.addUserToClient(response);

          this.shwUserCreation = false;
        })
        .catch(() => {
          this.failureText = "Fail to create the user!";
          this.failure = true;
        });
    },
    handleUpdateRequestToImageStoragePath() {
      this.runLoading();

      delete this.targetedObj.cluster;
      delete this.targetedObj.users;

      this.updateClient({ id: this.targetedObj.id, obj: this.targetedObj })
        .then(() => {
          this.success = true;
          this.successText =
            "Image storage path has been updated successfully!";
        })
        .catch(() => {
          this.failure = true;
          this.failureText = "Fail to update image storage path!";
        });
    },
    handleUpdateRequestToImageStorageConfig() {
      this.runLoading();

      setTimeout(() => {
        this.shwEditImageConfig = false;
        this.shwConfirmPassword = false;
        this.shwPassword = false;
      }, 1000);

      this.updateClient({ id: this.targetedObj.id, obj: this.targetedObj })
        .then(() => {
          this.success = true;
          this.successText =
            "Image storage config has been updated successfully!";
        })
        .catch(() => {
          this.failure = true;
          this.failureText = "Fail to update image storage config!";
        });
    },
    handleUpdateRequestToClientObj() {
      this.runLoading();

      setTimeout(() => {
        this.shwQuestion = false;
      }, 1000);

      delete this.targetedObj.cluster;
      delete this.targetedObj.users;

      this.updateClient({ id: this.targetedObj.id, obj: this.targetedObj })
        .then(() => {
          this.success = true;
          this.successText = `${
            this.questionType && this.questionType === "sync"
              ? "cluster"
              : "Activeness"
          } has been successfully ${
            this.questionType && this.questionType === "sync"
              ? "synced"
              : "changed"
          }!`;
        })
        .catch(() => {
          this.failure = true;
          this.failureText = `Failed to ${
            this.questionType && this.questionType === "sync"
              ? `sync cluster`
              : "change activeness"
          }!`;
        });
    },
    handleUpdateRequestToUserObj() {
      let roles = [];
      roles.push(this.targetedObj.roles);

      this.runLoading();

      setTimeout(() => {
        this.shwQuestion = false;
      }, 1000);

      this.updateUser({
        id: this.targetedObj.id,
        obj: { roles: roles },
      })
        .then(() => {
          this.success = true;
          this.successText = `${
            this.questionType && this.questionType === "sync"
              ? "role"
              : "Activeness"
          } has been successfully ${
            this.questionType && this.questionType === "sync"
              ? "synced"
              : "changed"
          }!`;
        })
        .catch(() => {
          this.failure = true;
          this.failureText = `Failed to ${
            this.questionType && this.questionType === "sync"
              ? `sync role to`
              : "change activeness"
          }!`;
        });
    },
    handleUpdateRequestToUserPermissions() {
      this.runLoading();

      setTimeout(() => {
        this.shwQuestion = false;
      }, 1000);

      this.updateUser({
        id: this.targetedObj.id,
        obj: { permissions: this.targetedObj.permissions },
      })
        .then(() => {
          this.success = true;
          this.successText = `${
            this.questionType && this.questionType === "sync"
              ? "permission"
              : "Activeness"
          } has been successfully ${
            this.questionType && this.questionType === "sync"
              ? "synced"
              : "changed"
          }!`;
        })
        .catch(() => {
          this.failure = true;
          this.failureText = `Failed to ${
            this.questionType && this.questionType === "sync"
              ? `sync permission to`
              : "change activeness"
          }!`;
        });
    },
    updateImageStorage() {
      this.questionText = `You will edit client image storage data.`;
      this.questionConfirmBtnText = "Edit";

      this.shwQuestion = true;
    },
    updateClientObj(obj) {
      this.targetType = "cluster";
      this.targetedObj = obj;

      if (this.questionType === "sync") {
        this.questionText = `You will sync cluster to ${this.targetedObj.name} client.`;
        this.questionConfirmBtnText = "Sync";
      } else if (this.questionType === "activeness") {
        this.targetedObj = new Object({
          id: this.targetedObj.id,
          is_active: this.targetedObj.is_active,
        });

        this.questionText = `You will change client ${this.targetedObj.name} activeness.`;
        this.questionConfirmBtnText = "Change";
      }

      this.shwQuestion = true;
    },
    updateUserDataPartially(obj, key) {
      this.updateUser({ id: obj.id, obj })
        .then(() => {
          this.success = true;
          this.successText = `User's ${key} has been updated successfully!`;
        })
        .catch(() => {
          this.failure = true;
          this.failureText = `Fail to update user's ${key}!`;
        });
    },
    updateUserPermissions(obj) {
      this.targetType = "permissions";
      this.targetedObj = obj;

      this.questionText = "You will sync user to selected permissions.";
      this.questionConfirmBtnText = "Sync";

      this.shwQuestion = true;
    },
    updateUserObj(obj) {
      this.targetType = "role";
      this.targetedObj = obj;

      if (this.questionType === "sync") {
        this.questionText = "You will sync user to selected roles.";
        this.questionConfirmBtnText = "Sync";
      } else if (this.questionType === "activeness") {
        this.targetedObj = new Object({
          id: this.targetedObj.id,
          is_active: this.targetedObj.is_active,
        });

        this.questionText = `You will change ${obj.name} activeness.`;
        this.questionConfirmBtnText = "Change";
      }

      //if (obj.roles.length && this.questionType === "sync") {
      this.shwQuestion = true;
      // } else {
      //   this.warning = true;
      //   this.warningText = "User has to have minimum 1 synced role!";
      // }
    },
    cancelEditDialog() {
      this.failureMessage = "Editing has been canceled";
      this.failure = true;
    },
  },
};
</script>

<style>
.no-border-bottom > .v-input__control > .v-input__slot:after,
.no-border-bottom > .v-input__control > .v-input__slot:before {
  width: 0 !important;
}
</style>
